import { Navigate, Outlet } from 'react-router-dom';
import { useContext } from 'react';
import { UserContext } from '../context/UserContext';
import { ROUTES } from './constants';

/**
 * Gate for the smart-link routes, which are a creator-only feature. Brand users
 * who still hold a bookmark are sent back to their dashboard rather than shown
 * a page their navigation no longer offers.
 */
const CreatorOnlyRoutes = () => {
  const user = useContext(UserContext)?.user;

  if (user?.role === 'brandUser') {
    return <Navigate to={ROUTES.HOME} replace />;
  }

  return <Outlet />;
};

export default CreatorOnlyRoutes;
